// extracted by mini-css-extract-plugin
export default {"tabsContainer":"styles_tabsContainer__lRyA6","tabs":"styles_tabs__fvbRU","tab":"styles_tab__2RlMA","slider":"styles_slider__SaguY","active":"styles_active__dFx7R"};